// @flow
import * as csx from 'csstips';
import classify from '@src/utils/typestyle';

import { regularGrayText } from '@src/styles/general';

const styles = classify({
  container: {
    ...csx.horizontal,
    ...csx.center,
    height: '100%'
  },
  giaLogo: {
    marginLeft: '11px',
    marginRight: '10px',
    height: '25px',
    width: '25px'
  },
  entity: {
    display: 'block',
    paddingTop: '3px',
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '600',
    color: regularGrayText
  },
  link: {
    fontSize: '13px',
    lineHeight: '16px',
    textDecoration: 'underline',
    color: '#1c487e'
  }
});

type PropsType = {
  url: string
};

const giaLogo = '/images/gia.jpg';

export default class CertificateInfo extends React.Component<PropsType> {
  render () {
    return (
      <div className={styles.container}>
        <div>
          <img className={styles.giaLogo} src={giaLogo} />
        </div>
        <div>
          <span className={styles.entity}>GIA Certificate</span>
          <a className={styles.link} target="_blank" href={this.props.url}>
            view
          </a>
        </div>
      </div>
    );
  }
}
